import { cva } from 'class-variance-authority';
import { Sizes } from '../enums/sizes';

export const dialogContentVariants = cva(
  'fixed left-[50%] top-[50%] z-100 w-full translate-x-[-50%] translate-y-[-50%] border bg-primary shadow-lg',
  {
    variants: {
      size: {
        [Sizes.MD]: 'grid max-w-lg gap-4 p-6 sm:rounded-lg',
        [Sizes.LG]:
          // overflow-clip (not hidden): scrollIntoView must not scroll the dialog shell
          'flex h-[720px] max-h-[calc(100vh-4rem)] w-[1020px] max-w-[calc(100vw-4rem)] overflow-clip rounded-2xl p-0',
      },
    },
    defaultVariants: {
      size: Sizes.MD,
    },
  }
);
